import { ReactNode } from 'react';
import './Badge.css';

export function Badge({ children }: { children: ReactNode }) {
  return <span className="badge">{children}</span>;
}
